/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const filterComponentsBySearchTerm = (components, term) => {
    return term && components.filter((componentType) => {
        return componentType.label?.toLowerCase().includes(term.toLowerCase());
    });
};

export const filterComponentsByCategory = (components, category) => {
    return category && components.filter((componentType) => {
        return componentType.categories?.includes(category);
    });
};

const sortItemsAtoZ = (items, compareKey) => {
    const compareFn = (a, b) => {
        const nameA = a[compareKey]?.toLowerCase();
        const nameB = b[compareKey]?.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    };
    return items.sort(compareFn);
};

export const sortComponentsAtoZ = (components) => {
    return sortItemsAtoZ(components, "label");
};

export const sortComponentsZtoA = (components) => {
    const compareFn = (a, b) => {
        const nameA = a.label?.toLowerCase();
        const nameB = b.label?.toLowerCase();
        if (nameA < nameB) {
            return 1;
        }
        if (nameA > nameB) {
            return -1;
        }
        return 0;
    };
    return components.sort(compareFn);
};

export const getFilteredComponentCategories = (categories, components) => {
    const componentCategories = components.map((component) => {
        return component.category;
    });
    return categories.filter((category) => {
        return componentCategories.includes(category.category);
    });
};

export const getSortedComponentCategoryNames = (categories) => {
    const sortedCategories = sortItemsAtoZ(categories, "name");
    return sortedCategories.map((category) => {
        return category.name;
    });
};
